import { provider } from "../../providers";
import { ILatestGamesViewRow } from "@grassrootly/api/providers/supabase-provider/actions/GetLatestGames";

// Gateway wrapper for fetching latest games from games_view
export type ILatestGame = ILatestGamesViewRow;

export const GetLatestGames = async (): Promise<ILatestGame[]> =>
  provider.Request<{}, ILatestGame[]>("/latest-games", {} as any);
